var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigCommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_22086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8063 17.079H19.5901C20.6663 17.079 21.3476 16.4865 21.3476 15.5352C21.3476 14.639 20.6663 13.9927 19.5901 13.9927H15.8063C15.6813 13.9927 15.5726 14.1002 15.5726 14.2077V16.864C15.5913 16.989 15.6801 17.079 15.8063 17.079ZM15.8063 23.199H19.7163C20.9176 23.199 21.6351 22.589 21.6351 21.5115C21.6351 20.579 20.9538 19.824 19.7163 19.824H15.8063C15.6813 19.824 15.5726 19.9327 15.5726 20.0402V22.9652C15.5913 23.109 15.6801 23.199 15.8063 23.199ZM29.6501 0.0664976L18.4588 11.229H20.2888C23.1401 11.229 24.8263 13.0227 24.8263 14.979C24.8263 16.5227 23.7863 17.654 22.6738 18.1552C22.4951 18.2277 22.4951 18.479 22.6913 18.5502C23.9826 19.0527 24.8976 20.4002 24.8976 21.9777C24.8976 24.2027 23.4101 25.9802 20.5226 25.9802H12.5951C12.4701 25.9802 12.3613 25.8727 12.3613 25.7652V17.3127L0.077559 29.5502C-0.0849409 29.7127 0.023809 29.999 0.256309 29.999H29.7951C29.8472 29.9984 29.8971 29.9773 29.934 29.9404C29.9709 29.9035 29.9919 29.8537 29.9926 29.8015V0.227748C30.0463 0.0302476 29.7951 -0.0772524 29.6513 0.0652476L29.6501 0.0664976Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_22086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCommerce);
export default __webpack_public_path__ + "static/media/bigCommerce.f7b8d4e33ac182087705d98b07330c31.svg";
export { ForwardRef as ReactComponent };